<template>
  <div class="box">
      <div v-for="(orderMaterialExpress,index) in orderMaterialExpressList" :id="index">
        <div class="mod">
          <div class="wrap1">
            <div class="layer1">
              <span class="express-info" v-if="orderMaterialExpress.expressNo !== ''">快递单号：{{ orderMaterialExpress.expressNo }}</span>
              <span class="express-info" v-else>快递单号：待填写</span>
              <div style="margin-top: 9px;">
                <display-icon-and-status :displayStatusName = orderMaterialExpress.displayStatusName :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE"></display-icon-and-status>
              </div>
            </div>
            <div class="line"></div>
            <div v-for="(expressMaterialDetail,index) in orderMaterialExpress.expressMaterialDetailList" :id="index">
              <div class="layer3 flex-row">
                <display-icon-and-status :materialType = expressMaterialDetail.orderMaterialInfo.materialType :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON"></display-icon-and-status>
                <span class="txt3">{{ expressMaterialDetail.orderMaterialInfo.materialDesc }}</span>
                <span class="status">{{ expressMaterialDetail.displayStatusName }}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="layer5 flex-row">
              <span class="info2">创建时间：{{ orderMaterialExpress.createDT }}</span>
              <span class="txt4">共{{ orderMaterialExpress.expressMaterialDetailList.length }}类物品</span>
            </div>
            <div class="layer6 flex-col" @click="modifyInfo(orderMaterialExpress)"><span class="info3">修改信息</span></div>
          </div>
        </div>
      </div>
      <div style="color: #D2D2D6; text-align: center;pointer-events:none;">
        <p style="font-size: 12px; margin-bottom: 50%;">---我是有底线的---</p>
      </div>
    </div>
</template>
<script>
  import EMKT from '../../emkt'
  import DisplayIconAndStatus from './DisplayIconAndStatus'
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: 'MySampleDeliverySheet',
    components: {DisplayIconAndStatus},
    computed: {
      ...mapGetters(['getOrderMaterialInfo'])
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        orderMaterialExpressList: []
      }
    },
    activated () {
      // 来自修改界面的返回
      this.fetchData()
    },
    methods: {
      ...mapMutations(['REASSEMBLE_ORDER_MATERIAL_INFO']),
      fetchData () {
        var _this = this
        _this.orderMaterialExpressList = this.$route.params.orderMaterialExpressList
        let params = {json: this.getOrderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress'}
        this.gcapi('invokeBsmMethod', params).then((res) => {
          if (res.body.result !== '[]') {
            this.orderMaterialExpressList = JSON.parse(res.body.result)
          }
        })
      },
      modifyInfo (materialExpress) {
        this.$weui.loading('加载中')
        let params = {json: materialExpress.orderMaterialExpressId, method: 'loadOrderMaterialExpressDetail'}
        this.gcapi('invokeBsmMethod', params).then((res) => {
          this.REASSEMBLE_ORDER_MATERIAL_INFO(JSON.parse(res.body.result))
          this.$router.push({
            name: 'AddSampleDeliverySheet',
            params: {fromType: EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery}
          })
          this.$weui.loading('加载中').hide()
        })
      }
    }
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: rgba(250, 250, 250, 1);
    justify-content: flex-start;
    padding-top: 0;
  }

  .mod {
    height: auto;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 10px;
    width: 100%;
    justify-content: center;
  }

  .wrap1 {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .layer1 {
    width: 91%;
    margin-left: 15px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
  }

  .express-info {
    width: 96px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-top: 11px;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #EFEEF3;
    margin-top: 11px;
  }

  .layer3 {
    width: 90%;
    height: 29px;
    justify-content: space-between;
    margin: 9px 0 0 15px;
  }

  .txt3 {
    width: 80%;
    height: 21px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 13px;
    white-space: nowrap;
    line-height: 21px;
    text-align: justify;
    margin-top: 4px;
    margin-left: 10px;
  }

  .status {
    height: 14px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(254, 101, 77, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 14px;
    text-align: left;
    margin-top: 8px;
  }

  .layer5 {
    z-index: auto;
    width: 91%;
    height: 14px;
    justify-content: space-between;
    margin: 5px 0 0 15px;
  }

  .info2 {
    z-index: 113;
    width: 153px;
    height: 14px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 14px;
    text-align: left;
  }

  .txt4 {
    width: 46px;
    height: 14px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 14px;
    text-align: right;
  }

  .layer6 {
    height: 23px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    background-color: rgba(88, 120, 250, 1);
    align-self: flex-end;
    width: 73px;
    justify-content: center;
    margin: 10px 15px 10px 0;
  }

  .info3 {
    z-index: 106;
    width: 73px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// MySampleDeliverySheet.vue?68b10dd8